import { render } from "./Submission.vue?vue&type=template&id=65cac9da&scoped=true"
import script from "./Submission.vue?vue&type=script&lang=js"
export * from "./Submission.vue?vue&type=script&lang=js"

import "./Submission.vue?vue&type=style&index=0&id=65cac9da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65cac9da"]])

export default __exports__